import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
export default function createPortalAttachment() {
  var displayName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PortalAttachment';
  var Context = /*#__PURE__*/React.createContext();

  function Container(_ref) {
    var _ref$as = _ref.as,
        ElementType = _ref$as === void 0 ? 'div' : _ref$as,
        rest = _objectWithoutProperties(_ref, ["as"]);

    var _useContext = useContext(Context),
        setContainer = _useContext.setContainer,
        setContainerCount = _useContext.setContainerCount;

    useEffect(() => {
      setContainerCount(count => count + 1);
      return () => setContainerCount(count => count - 1);
    }, [setContainerCount]);
    return /*#__PURE__*/React.createElement(ElementType, _extends({
      ref: setContainer
    }, rest));
  }

  Container.displayName = "".concat(displayName, ".Container");
  Container.propTypes = {
    as: PropTypes.elementType
  };

  function Provider(_ref2) {
    var children = _ref2.children;

    var _useState = useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        containerCount = _useState2[0],
        setContainerCount = _useState2[1];

    var _useState3 = useState(null),
        _useState4 = _slicedToArray(_useState3, 2),
        container = _useState4[0],
        setContainer = _useState4[1];

    if (containerCount > 1) {
      throw new Error("Multiple <".concat(displayName, ".Container> elements detected; only one may be mounted at a time."));
    }

    var value = useMemo(() => ({
      container,
      setContainer,
      setContainerCount
    }), [container]);
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: value
    }, children);
  }

  Provider.displayName = "".concat(displayName, ".Provider");
  Provider.propTypes = {
    children: PropTypes.node
  };

  function PortalAttachment(_ref3) {
    var children = _ref3.children;
    var context = useContext(Context);

    if (!context) {
      throw new Error("".concat(displayName, " context not found, did you forget to add a <").concat(displayName, ".Provider>?"));
    }

    var container = context.container;

    if (!container) {
      return null;
    }

    return /*#__PURE__*/ReactDOM.createPortal(children, container);
  }

  PortalAttachment.displayName = displayName;
  PortalAttachment.Container = Container;
  PortalAttachment.Context = Context;
  PortalAttachment.Provider = Provider;
  return PortalAttachment;
}